<template>
  <div :class="['custom-overlay', {animate: animate}]" v-show="visible">
    <template v-if="type==='custom'">
      <div class="dialog-card is-custom" :class="{center:center}" :style="{'width':modalWidth}">
        <div v-if="showClose" class="btn-close" @click="$emit('update:visible', false)"><span></span></div>
        <slot />
      </div>
    </template>
    <template v-else>
      <div class="dialog-card" :class="{center:center}" :style="{'width':modalWidth}">
        <div v-if="showClose" class="btn-close" @click="$emit('update:visible', false)"><span></span></div>
        <slot />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BaseDialog',

  props: {
    visible: Boolean,
    showClose:{
      type:Boolean,
      default:true
    },
    center:{
      type:Boolean,
      default:false
    },
    modalWidth:{
      type:String,
      default:'6.5rem'
    },
    type: {
      type: String,
      default: 'normal'
    }
  },

  data () {
    return {
      animate: false
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.animateShow()
      } else {
        this.animate = false
      }
    }
  },

  mounted () {
    if (this.visible) this.animateShow()
  },

  methods: {
    animateShow () {
      setTimeout(() => {
        this.animate = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.8);
  overflow-y: auto;
  opacity: 0;
  transition: all .3s;
  &.animate {
    opacity: 1;
  }
  .dialog-card {
    position: relative;
    width: 650px;
    margin: 1.22rem auto;
    border-radius: 6px;
    background-color: #fff;
    overflow: hidden;
    &.is-custom {
      border-radius: 16px;
    }
    &.center{
      margin: 3.5rem auto;
    }
    .btn-close {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      padding: 10px;
      span {
        display: block;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background: #e5e5e5 url('../assets/icons/icon_close2.png') center center no-repeat;
        background-size: 15px;
      }
    }
  }
}
</style>
